export type ReceivedProps = Record<string, any>;

const useBusinessTripReportsCategoryStatus = (props: ReceivedProps) => {
  return {
    ...props,
  };
};

export type Props = ReturnType<typeof useBusinessTripReportsCategoryStatus>;

export default useBusinessTripReportsCategoryStatus;
